import React, { useRef, useEffect, useCallback } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { gsap } from 'gsap/all';

export default function ButtonHeaderSubMenu({ title, options, isOpen, onToggle, onClose }) {

    const location = useLocation();
    const subMenuRef = useRef(null);
    const prevOpenRef = useRef(false);

    let selected = options.some(opt => location.pathname === opt?.path);

    // Animate open/close when isOpen changes
    useEffect(() => {
        if (!subMenuRef.current) return;
        if (isOpen && !prevOpenRef.current) {
            subMenuRef.current.style.display = 'block';
            subMenuRef.current.style.top = '75%';
            subMenuRef.current.style.opacity = 0;
            gsap.to(subMenuRef.current, 0.3, { top: '80%', opacity: 1 });
        } else if (!isOpen && prevOpenRef.current) {
            gsap.killTweensOf(subMenuRef.current);
            subMenuRef.current.style.display = 'none';
        }
        prevOpenRef.current = isOpen;
    }, [isOpen]);

    const handleClick = useCallback((e) => {
        e.stopPropagation();
        onToggle(title);
    }, [onToggle, title]);

    const optionsList = options.map((option, i) => (
        <li key={i} className='sub--menu-item'>
            <NavLink
                className='header--nav__link-in-sub-menu'
                activeClassName='header--nav__link-selected'
                to={option.path}
                onClick={onClose}
            >
                <span className="header--nav__link-in-sub-menu-inner">
                    <span className='menu-hover-line'></span>
                    {option.title}
                </span>
            </NavLink>
        </li>
    ));

    const btnClass = [
        selected ? 'header--nav__link-selected' : 'header--nav__link',
        'main--menu__link-wrapper',
        isOpen ? 'touch-highlighted' : '',
    ].filter(Boolean).join(' ');

    return (
        <div>
            <button
                className={btnClass}
                onClick={handleClick}
            >
                <div className='main--menu__link'>
                    {title}
                </div>
            </button>

            <div className='header--nav__sub-menu' ref={subMenuRef}>
                <ul>
                    {optionsList}
                </ul>
            </div>
        </div>
    );
}
